import React from "react";
import {
    Typography,
    MenuItem,
    Popover,
    styled
  } from '@mui/material';
import { CommonPopoverProps } from '../../blocks/navigationmenu/src/NavigationMenuController';

const CustomMenu = styled(MenuItem)({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  padding: "11px 18px",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.05)"
  },
  "& p": {
    fontSize: "0.875rem",
    fontWeight: 500,
    letterSpacing: "-0.15px"
  }
})

export const CommonPopover: React.FC<CommonPopoverProps> = ({ anchorEl, open, menus, onClose }) => {
    return (
      <Popover
        data-test-id="profileMenu"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={onClose}
        sx={{
          mt: 1.5,
          "& .MuiPopover-paper": {
            padding: "0px",
            minWidth: "180px",
            borderRadius: "8px",
            boxShadow: "none",
            minHeight: "152px",
            border: "1px solid #CBD5E1",
            marginTop: "-4px"
          },
        }}
      >
        {menus.map((menu) => {
          const { icon, title, handleClick } = menu
          return (
            <CustomMenu
              key={title}
              data-test-id="header-menu"
              onClick={handleClick}
            >
              {icon}
              <Typography variant="body1">{title}</Typography>
            </CustomMenu>
          )
        })}
      </Popover>
    );
  };